
export default {
  name: "ypanachorisi",
  data() {
    return {
      step: 1,
      fid: (this.$route.query || {}).id || "",
      email: (this.$route.query || {}).email || ((this.$store.getters.user || {}).email || ""),
      name: "",
      reason: "",
      error: "",
      sending: false,
    };
  },
  head() {
    return {
      title: `Υπαναχώρηση από τη σύμβαση | ${this.$store.getters.store.eshop.name}`,
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Δήλωση υπαναχώρησης από τη σύμβαση εντός 14 ημερών από την παραλαβή της παραγγελίας.",
        },
      ],
    };
  },
  computed: {
    valid() {
      return (
        (this.fid + "").trim() &&
        /.+@.+\..+/.test(this.email) &&
        (this.name + "").trim()
      );
    },
  },
  methods: {
    toConfirm() {
      this.error = "";
      if (!this.valid) return;
      this.step = 2;
    },
    async submit() {
      if (this.sending) return;
      this.sending = true;
      this.error = "";
      try {
        let res = await this.$axios.$post(
          `orders/withdrawal?store_id=${this.$store.getters.store.id}`,
          {
            store_id: this.$store.getters.store.id,
            fid: parseInt((this.fid + "").replace(/\D/g, ""), 10),
            email: (this.email + "").trim(),
            name: (this.name + "").trim(),
            reason: (this.reason + "").trim(),
          }
        );
        if (res.success) {
          this.step = 3;
        } else if (res.message == "already_requested") {
          this.error =
            "Έχει ήδη καταχωρηθεί δήλωση υπαναχώρησης για αυτή την παραγγελία.";
        } else {
          this.error = "Κάτι πήγε στραβά. Προσπάθησε ξανά.";
        }
      } catch (e) {
        if ((e.response || {}).status == 404) {
          this.error =
            "Δεν βρέθηκε παραγγελία με αυτόν τον αριθμό και email. Έλεγξε τα στοιχεία.";
          this.step = 1;
        } else {
          this.error = "Κάτι πήγε στραβά. Προσπάθησε ξανά.";
        }
      }
      this.sending = false;
    },
  },
};
